export default {
  LEFT: 'left',
  RIGHT: 'right',
  CENTER: 'center',
};
